import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../services/supabaseClient';

const DashboardMember = () => {
  const { session, memberStatus } = useAuth();
  const [membershipNumber, setMembershipNumber] = useState(null);
  const [isNumberLoaded, setIsNumberLoaded] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchMembershipNumber = async () => {
      if (!session?.user?.id) return;
      try {
        const { data, error } = await supabase
          .from('registrations')
          .select('membership_number')
          .eq('user_id', session.user.id)
          .maybeSingle();

        if (error) throw error;
        if (isMounted) setMembershipNumber(data?.membership_number || null);
      } catch (err) {
        console.error('Error fetching nomor anggota:', err);
      } finally {
        if (isMounted) setIsNumberLoaded(true);
      }
    };

    fetchMembershipNumber();
    return () => { isMounted = false; };
  }, [session]);

  // Stat cards data (menggunakan STRICTLY warna emerald-* sesuai brand guide)
  const stats = [
    { name: 'Status Anggota', value: memberStatus || '-', icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z', color: 'bg-emerald-50 text-emerald-800' }, // Dark Green
    { name: 'Nomor Anggota', value: isNumberLoaded ? (membershipNumber || '-') : '...', icon: 'M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2', color: 'bg-emerald-50 text-emerald-600' }, // Primary Blue
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-800">Dashboard Anggota</h1>
        <p className="mt-1 text-sm text-slate-500">Ringkasan status keanggotaan dan profil institusi pesantren Anda.</p>
      </div>

      {/* Stat Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        {stats.map((item) => (
          <div key={item.name} className="bg-white overflow-hidden shadow-sm rounded-xl border border-slate-200 hover:shadow-md transition-shadow">
            <div className="p-5">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className={`p-3 rounded-md ${item.color} border border-slate-100 shadow-sm`}>
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={item.icon} />
                    </svg>
                  </div>
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-slate-500 truncate">{item.name}</dt>
                    <dd className="text-2xl font-bold text-slate-900">{item.value}</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Welcome Banner */}
      <div className="bg-emerald-700 rounded-xl shadow-md overflow-hidden mt-8 relative">
        <div className="absolute top-0 right-0 -mr-16 -mt-16 text-white opacity-10">
          <svg className="w-64 h-64" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
          </svg>
        </div>
        <div className="px-6 py-8 relative z-10 sm:p-10">
          <h3 className="text-2xl font-bold text-white mb-2">Selamat datang di HEBIPEDIA!</h3>
          <p className="text-emerald-50 max-w-2xl text-lg">
            HEBIPEDIA akan memudahkan institusi Anda dalam memperbarui data keanggotaan dan terhubung dengan jaringan bisnis pesantren se-nusantara.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DashboardMember;
